import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {LoaderRedux} from '../../../components/LoaderRedux'
import {getTiposDocumentoEmision} from '../../../actions/catalogos.actions'
import {EJEMPLO_SERIE_V2} from '../../../utils/series.utils'
import TablaSeries from './Components/TablaSeries'
import ModalEditarSerie from './modals/ModalEditarSerie'
import {SerieDocumento, useSeriesDocumentos} from './useSeriesDocumentos'

const SeriesDocumentos = () => {
  const dispatch = useDispatch()
  const {
    series,
    cargando,
    errorCarga,
    guardando,
    consultado,
    normativaV2,
    cargarSeries,
    guardarSerie,
  } = useSeriesDocumentos()

  const [documentoEnEdicion, setDocumentoEnEdicion] = useState<SerieDocumento | null>(null)

  useEffect(() => {
    window.scroll(0, 0)
    dispatch(getTiposDocumentoEmision())
    cargarSeries()
  }, [])

  const correctas = series.filter((documento) => documento.cumpleFormatoV2).length
  const porCorregir = series.length - correctas

  return (
    <BasicLayout>
      {cargando && <LoaderRedux />}
      {documentoEnEdicion && (
        <ModalEditarSerie
          documento={documentoEnEdicion}
          guardando={guardando}
          onCancelar={() => setDocumentoEnEdicion(null)}
          onGuardar={(serie: string) => guardarSerie(documentoEnEdicion, serie)}
        />
      )}

      <div className='header-link'>
        <Link to='/gestion-usuarios' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Series de documentos</h3>
      </div>
      <div className='separador'></div>

      <div className='container-white w-100'>
        <div className='card-basic w-100'>
          <h4 className='h4-titles' style={{marginTop: 0}}>
            Puede corregir sus series desde ya, sin riesgo
          </h4>
          <p className='s' style={{marginBottom: '8px'}}>
            El formato de la Normativa 2.0 es <strong>{EJEMPLO_SERIE_V2}</strong>: una letra de
            establecimiento (M casa matriz, B bodega, S sucursal, P patio), su número de tres
            dígitos, la letra P y el número de punto de venta de tres dígitos.
          </p>
          <p className='s' style={{marginBottom: '8px'}}>
            Ese formato es un <strong>subconjunto del formato anterior</strong>, que admite ocho
            caracteres alfanuméricos. Una serie como <strong>{EJEMPLO_SERIE_V2}</strong> cumple las
            dos reglas, así que{' '}
            <strong>sigue siendo válida mientras usted emite en la versión 1</strong>.
          </p>
          <p className='s' style={{marginBottom: 0}}>
            Por eso puede dejar sus series listas con calma, desde hoy y sin ventana de
            mantenimiento: cuando su empresa pase a la Normativa 2.0 no tendrá que detener la
            emisión para corregirlas.
          </p>
        </div>
      </div>

      <div className='container-white w-100'>
        <div className='card-basic w-100 mt-16'>
          <div className='mb-16'>
            <h3 className='card-title l mb-16'>Series registradas</h3>
            {!cargando && !errorCarga && series.length > 0 && (
              <p className='s' style={{marginTop: 0, marginBottom: 0}}>
                {porCorregir === 0
                  ? `Sus ${series.length} series ya cumplen el formato de la Normativa 2.0.`
                  : `${correctas} de ${series.length} series cumplen el formato de la Normativa 2.0. Le quedan ${porCorregir} por corregir.`}
                {normativaV2
                  ? ' Su empresa ya emite con la Normativa 2.0.'
                  : ' Su empresa todavía emite con la versión 1.'}
              </p>
            )}
            <div className='separador' style={{opacity: '10%', marginTop: '16px'}}></div>
          </div>

          {errorCarga && (
            <div>
              <p className='alert s'>{errorCarga}</p>
              <button
                className='m button w-auto'
                onClick={() => cargarSeries()}
                disabled={cargando}
              >
                <div>Reintentar</div>
              </button>
            </div>
          )}

          {!errorCarga && consultado && !cargando && series.length === 0 && (
            <p className='s'>
              No encontramos documentos con serie registrada. Agregue sus documentos en Estado de
              Sucursales y Documentos y vuelva a esta pantalla.
            </p>
          )}

          {!errorCarga && series.length > 0 && (
            <TablaSeries
              series={series}
              onCorregir={(documento: SerieDocumento) => setDocumentoEnEdicion(documento)}
            />
          )}
        </div>
      </div>
    </BasicLayout>
  )
}

export default SeriesDocumentos
